<template>
  <div class="news_details_wrap news-detail-page">
    <PCNavbar selectIndex="4-2"/>
    <MobileNavBar :currentActive="3"/>
    <div class="news_content">
      <el-breadcrumb class="news_bread" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>

      <article class="news_article">
        <header class="news_article_header">
          <h1 class="news_title">
            济南能源集团和瑞运营管理公司领导莅临我司参观交流
          </h1>
          <div class="news_meta">
            <span class="news_meta_item">来源：山东智能工业装备公司</span>
            <span class="news_meta_sep">·</span>
            <span class="news_meta_item">投稿时间：2026-07-08</span>
          </div>
        </header>

        <div class="article_body">
          <p class="lead">
            2026年7月8日上午，济南能源投资控股集团旗下子公司——济南和瑞运营管理有限公司领导一行莅临山东智能工业装备有限公司参观交流。我司相关负责人热情接待，双方围绕新能源充电桩产品、能碳管理平台及未来合作方向进行了深入友好的座谈交流。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img1"
              alt="来访参观"
            >
            <figcaption class="figure_caption">来访参观</figcaption>
          </figure>

          <h2 class="section_title">一、厂区参观与产品展示</h2>

          <p class="body_paragraph">
            来访领导首先参观了我司的厂区。我司技术人员重点介绍了720KW四轮充电桩产品，详细讲解了其输出规格、智能通信接口及远程监控能力。该产品输出稳定、部署灵活，可广泛适用于商业停车场、公共充电站等四轮车充电场景，来访领导对产品性能给予了高度关注，并就部分技术细节进行了深入探讨。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img2"
              alt="720KW四轮充电桩产品展示"
            >
            <figcaption class="figure_caption">720KW四轮充电桩产品展示</figcaption>
          </figure>

          <p class="body_paragraph">
            随后，来访领导前往二轮智能充电桩区域进行参观。我司现场展示了二轮充电桩的整体部署方案及运营管理模式。该设备支持微信扫码充电，每台配备多个充电端口，可满足多车同时充电需求；内置过流保护、过压保护、短路保护及漏电保护等多重安全机制，从硬件层面有效防范充电隐患，切实解决城市非机动车停放区的充电难题。来访领导对产品的便捷性、安全性与实用性表示认可。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img3"
              alt="二轮智能充电桩区域参观"
            >
            <figcaption class="figure_caption">二轮智能充电桩区域参观</figcaption>
          </figure>

          <p class="body_paragraph">
            在产品展示区，我司向来访领导全面介绍了公司的核心产品线及研发实力，重点展示了与北京理工大学联合研发项目的系列成果，并就相关资质证书与荣誉奖项进行了说明。来访领导对我司在新能源电源领域的技术积累和创新能力给予了充分肯定。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img4"
              alt="核心产品与研发实力介绍"
            >
            <figcaption class="figure_caption">核心产品与研发实力介绍</figcaption>
          </figure>

          <h2 class="section_title">二、座谈交流会</h2>

          <p class="body_paragraph">
            参观结束后，双方移步至会议室召开座谈交流会。会上，我司详细介绍了目前主要的合作形式，涵盖设备供应、技术合作及项目共建等多个维度。济南和瑞运营管理公司领导也介绍了其负责的业务方向，包括能源运营管理、新能源设施建设及运营等领域的业务布局。双方就各自的优势与需求进行了充分沟通，在多个潜在合作方向上达成了初步共识。
          </p>

          <figure class="figure_block figure_block--end">
            <img
              class="article_img"
              :src="images.img5"
              alt="座谈交流"
            >
            <figcaption class="figure_caption">座谈交流</figcaption>
          </figure>

          <p class="body_paragraph">
            此次济南和瑞运营管理公司领导莅临参观交流，进一步拓宽了我司在新能源领域的合作渠道，为后续项目的深入对接奠定了良好基础。双方表示将保持密切沟通，加快推动合作项目的落地实施，共同助力新能源产业发展。
          </p>
        </div>
      </article>
    </div>

    <div class="news_detail_page_foot">
      <CallMe/>
      <MobileCallme/>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/report_list/SpaNav.vue'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme,
  },
  data () {
    return {
      images: {
        img1: require('@/assets/images/news-list/news4/cover.png'),
        img2: require('@/assets/images/news-list/news4/image2.png'),
        img3: require('@/assets/images/news-list/news4/image4.png'),
        img4: require('@/assets/images/news-list/news4/image1.png'),
        img5: require('@/assets/images/news-list/news4/image3.png'),
      },
    }
  },
}
</script>

<style lang="scss">
@import '~@/assets/styles/news-detail-responsive.scss';
</style>
